define('TescoMobile_Checkout/js/view/about/marketing-preferences',['uiComponent'], function (Component) {
  'use strict';

  var checkoutConfig = window.checkoutConfig,
    marketingPreferencesConfig = checkoutConfig && checkoutConfig.tescomobile && checkoutConfig.tescomobile.marketingPreferences ? checkoutConfig.tescomobile.marketingPreferences : {},
    canShow = marketingPreferencesConfig === null || marketingPreferencesConfig === void 0 ? void 0 : marketingPreferencesConfig.canShow;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/about/marketing-preferences',
      preCopy: marketingPreferencesConfig.preCopy || '',
      postCopy: marketingPreferencesConfig.postCopy || ''
    },
    initObservable: function () {
      this._super();
      this.observe({
        isVisible: canShow
      });
      return this;
    }
  });
});

